import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CurrenciesView } from "src/components/views/erp/common/currencies/CurrenciesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/currencies")({
	staticData: { title: i18n.t("currencies"), legacyViewKey: "currenciesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CurrenciesView />;
}
